// Email validation regex pattern
// Matches standard email format: local@domain.tld
// - Local part: can contain letters, numbers, dots, underscores, percent, plus, hyphens
// - Domain: alphanumeric with optional hyphens and dots
// - TLD: at least 2 letters
const EMAIL_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

/**
 * Validates if a string is a valid email address
 */
export const isValidEmail = (email: string): boolean => {
  return EMAIL_PATTERN.test(email.trim());
};
